import React from "react";
import {
  TabbedShowLayout,
  Tab,
  ShowProps,
  TopToolbar,
  Button,
} from "react-admin";
import { Grid } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import Summary from "./Summary";
import ShowWrapper from "../../components/ShowWrapper";
import moment from "moment/moment";
import EditIcon from "@material-ui/icons/Edit";

const ShowAction = (props: any) => {
  const { data, history } = props;

  if (data && moment(data.date).isAfter(moment(), "day")) {
    return (
      <TopToolbar>
        <Button
          onClick={() => history.push(`/dryRunSchedules/${props.data?.id}`)}
          label="Edit"
        >
          <EditIcon />
        </Button>
      </TopToolbar>
    );
  } else {
    return <></>;
  }
};

const DryRunScheduleShow = (props: ShowProps) => {
  const { id } = props;

  const breadcrumb = [
    { link: "/dryRunSchedules", title: "Dry Run Schedules" },
    { link: `/dryRunSchedules/${id}`, title: id },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        isDefaultTitle
        actions={<ShowAction history={props.history} />}
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Summary">
                <Summary {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default DryRunScheduleShow;
